<template>
  <div class="d-flex justify-content-center">
    <vue-awesome-paginate
      pagination-container-class="pagination"
      paginate-buttons-class="page-link"
      active-page-class="active"
      :total-items="totleItems"
      :items-per-page="itemPerPage"
      :max-pages-shown="5"
      v-model="currentPage"
      @click="onClickHandler"
    >
      <template #prev-button>
        <span disabled>
          <i class="far fa-chevron-left"></i>
        </span>
      </template>

      <template #next-button>
        <span>
          <i class="far fa-chevron-right"></i>
        </span>
      </template>
    </vue-awesome-paginate>
  </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  page: {
    required: true,
  },
  totalPages: {
    required: true,
  },
  totleItems: {
    required: true,
  },
  itemPerPage: {
    required: true,
  },
});

const currentPage = ref(1);
const emit = defineEmits(["update:modelValue"]);

const onClickHandler = (currentPage) => {
  emit("update:modelValue", currentPage);
};
</script>


<style lang="scss" scoped>
@import "@/assets/scss/app";

ul.pagination {
  display: inline-flex;
  height: 36px;
  margin-top: 4.6rem;
  gap: 2.5px;

  :deep(li) {
    position: relative;
    height: 36px;

    .page-link {
      font-size: 18px;
      font-weight: 500;
      color: rgba($black-4, 0.6);
      height: 36px;
      align-items: center;
      justify-content: center;
      display: flex;
      flex-direction: column;

      &:hover {
        color: $yellow-ci;
      }
    }

    .back-button,
    .next-button {
      color: rgba($black-4, 1);
      background: $white;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      margin: 0 0.75rem;
    }

    &.disabled {
      .page-link {
        opacity: 0.5;
        pointer-events: none;
      }
    }
  }

  :deep(.page-link) {
    padding: 16px;
    color: rgba($black-4, 0.6);
    background-color: transparent;
    border: 0;

    @include media-breakpoint-up(lg) {
      padding: 0 12px;
    }

    @include hover-focus-active {
      outline: none;
      box-shadow: unset;
    }

    &.active {
      color: $yellow-ci;
    }
  }
}

.search-result {
  ul.pagination {
    margin-top: 10px ;
  }
}
</style>
